import { useQuery } from '@tanstack/react-query';
import { fetchHealth } from '../services/api/health';

/**
 * Polls /health so the dashboard can show whether the API and database are up.
 *
 * `retry: false` on purpose: when the backend is not running, a developer wants to
 * be told immediately, not after React Query has spent several seconds retrying.
 */
export function useHealth() {
  return useQuery({
    queryKey: ['health'],
    queryFn: fetchHealth,
    refetchInterval: 30_000,
    retry: false,
  });
}
